import { landingAssets } from 'assets/landing'
import { icons, images, logos, social } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token.css */
  .yolo_token_page_wrapper {
    width: 100%;
    padding: 0;
    min-width: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
  }
  .yolo_token_page_wrapper .yt_page_left {
    border-right: 1px solid hsla(0, 0%, 100%, 0.2);
    width: 50%;
    padding: 40px 0 0 0;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .yolo_token_page_wrapper .yt_page_left form {
    background: hsla(0, 0%, 100%, 0.05);
    width: 100%;
    padding: 40px 100px;
    margin: 30px 0;
    display: flex;
    flex-direction: column;
  }
  .yolo_token_page_wrapper .yt_page_left form fieldset {
    display: flex;
    flex-direction: column;
  }
  .yolo_token_page_wrapper .yt_page_left form fieldset label {
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 10px 0;
  }
  .yolo_token_page_wrapper .yt_page_left form fieldset input {
    border-radius: 10px;
    background: hsla(0, 0%, 100%, 0.1);
    padding: 10px 16px;
    font-size: 0.9rem;
    margin: 0 0 5px 0;
  }
  .yolo_token_page_wrapper .yt_page_left form fieldset button {
    border-radius: 10px;
    padding: 10px 16px;
    font-size: 0.9rem;
    height: 35px;
  }
  .yolo_token_page_wrapper .yt_page_left .qanda {
    padding: 0 100px;
  }
  .yolo_token_page_wrapper .yt_page_left .qanda .question {
    font-size: 1.4rem;
    font-weight: 600;
    padding: 0 0 15px 0;
    letter-spacing: -0.01em;
  }
  .yolo_token_page_wrapper .yt_page_left .qanda .answer {
    font-size: 0.9rem;
    line-height: 160%;
    padding: 0 0 30px 0;
    font-weight: 300;
  }
  .yolo_token_page_wrapper .yt_page_left .qanda .answer p {
    padding: 0 0 5px 0;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda {
    padding: 40px 0 0 0;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .question {
    font-size: 1.3rem;
    font-weight: 800;
    padding: 0 0 15px 0;
    letter-spacing: -0.01em;
    text-align: center;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .answer {
    padding: 0 0 30px 0;
    text-align: center;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .answer p {
    padding: 7px 0;
    font-size: 0.9rem;
    line-height: 160%;
    font-weight: 300;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .answer p b {
    font-weight: 800;
  }
  .yolo_token_page_wrapper .yt_page_right {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 40px 100px 0 100px;
  }
  .yolo_token_page_wrapper .yt_page_left .yt_logo_full {
    display: none;
  }
  .yolo_token_page_wrapper .yt_page_right .yt_logo_full {
    width: 350px;
    height: auto;
  }
  .yolo_token_page_wrapper h1 {
    font-size: 2.6rem;
    font-weight: 800;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    width: 100%;
    text-align: center;
    padding: 0 100px;
  }
  .yolo_token_page_wrapper h2 {
    font-size: 2.1rem;
    letter-spacing: -0.02em;
    font-weight: 200;
    padding: 10px 100px 0 100px;
    width: 100%;
    text-align: center;
  }
  .yolo_token_page_wrapper button.see_more {
    padding: 12px 20px;
    font-size: 1.1rem;
  }
  .yt_table_wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    width: 100%;
    margin: 20px 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }
  .yt_table_wrapper .subtitle {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 10px 0;
  }
  .yt_table_wrapper .grid-header {
    display: contents;
  }
  .yt_table_wrapper .grid-content {
    display: contents;
  }
  .yt_table_wrapper .table_row {
    display: contents;
  }
  .yt_table_wrapper .grid-body .grid-header label {
    position: sticky;
    top: 0;
    font-size: 0.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;
    border-top: 1px solid transparent;
    cursor: pointer;
    color: hsl(0, 0%, 100%, 0.4);
    background: hsla(0, 0%, 0%, 0.6);
    padding: 10px 12px 9px 12px;
    z-index: 1;
    opacity: 1;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-header label:first-child {
    border-radius: 10px 0 0 0;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-header label:last-child {
    border-radius: 0 0 0 10px;
  }
  .yt_table_wrapper .grid-body .grid-content label {
    padding: 14px 12px 13px 34px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    background: hsla(0, 0%, 100%, 0.07);
    font-size: 0.9rem;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    opacity: 1;
    line-height: 130%;
    position: relative;
  }
  .yt_table_wrapper .grid-body .grid-content label span {
    line-height: 120%;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-content label {
    padding: 14px 12px 13px 12px;
  }
  .yt_table_wrapper .grid-body .grid-content label:first-child {
    border-radius: 10px 10px 0 0;
  }
  .yt_table_wrapper .grid-body .grid-content label:last-child {
    border-radius: 0 0 10px 10px;
    border-bottom: 0;
  }
  .yt_table_wrapper .grid-body .grid-content label .title {
    font-weight: 800;
    padding: 0 10px 0 0;
    white-space: nowrap;
  }
  .yt_table_wrapper .grid-body .grid-content label:before {
    background: #fff;
    position: absolute;
    top: 50%;
    left: 14px;
    transform: translateY(-50%);
    width: 13px;
    height: 13px;
    content: '';
  }
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users {
    background: hsla(221, 73%, 47%, 0.4);
  }
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users b {
    font-weight: 700;
  }
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users:before {
    -webkit-mask: url(${logos.yolorekt_moon_white}) left center / 15px auto no-repeat;
    mask: url(${logos.yolorekt_moon_white}) left center / 15px auto no-repeat;
    width: 15px;
    height: 15px;
  }
  .yt_table_wrapper .grid-body .grid-content label.date:before {
    -webkit-mask: url(${icons.date_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.date_icon}) left center / 13px auto no-repeat;
    height: 15px;
  }
  .yt_table_wrapper .grid-body .grid-content label.token:before {
    -webkit-mask: url(${icons.token_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.token_icon}) left center / 13px auto no-repeat;
  }
  .yt_table_wrapper .grid-body .grid-content label.token_supply:before {
    -webkit-mask: url(${icons.supply_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.supply_icon}) left center / 13px auto no-repeat;
    height: 16px;
  }
  .yt_table_wrapper .grid-body .grid-content label.address:before {
    -webkit-mask: url(${icons.info_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.info_icon}) left center / 13px auto no-repeat;
  }
  .yt_table_wrapper .grid-body .grid-content label.token_price:before {
    -webkit-mask: url(${icons.token_price_icon}) left center / 15px auto no-repeat;
    mask: url(${icons.token_price_icon}) left center / 15px auto no-repeat;
    width: 15px;
    height: 16px;
    left: 12px;
  }
  .yt_table_wrapper .grid-body .grid-content label.min_buy_amount:before {
    -webkit-mask: url(${icons.min_buy_amount_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.min_buy_amount_icon}) left center / 13px auto no-repeat;
  }
  .yt_table_wrapper .grid-body .grid-content label.total_token_all:before {
    -webkit-mask: url(${icons.total_token_all_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.total_token_all_icon}) left center / 13px auto no-repeat;
  }
  .yt_table_wrapper .grid-body .grid-content label.vesting:before {
    -webkit-mask: url(${icons.vesting_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.vesting_icon}) left center / 13px auto no-repeat;
  }
  .yt_table_wrapper .grid-body .grid-content label.mechanism:before {
    -webkit-mask: url(${icons.mechanism_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.mechanism_icon}) left center / 13px auto no-repeat;
  }
  .yt_table_wrapper .grid-body .grid-content label.team_allocation:before {
    -webkit-mask: url(${icons.team_allocation_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.team_allocation_icon}) left center / 13px auto no-repeat;
  }
  .yt_table_wrapper .grid-body .grid-content label.seed_investors_allocation:before {
    -webkit-mask: url(${icons.seed_investors_allocation_icon}) left center / 13px auto no-repeat;
    mask: url(${icons.seed_investors_allocation_icon}) left center / 13px auto no-repeat;
    height: 15px;
  }
  .yt_table_wrapper .grid-body {
    display: grid;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 0 0 30px 0;
  }
  .yt_table_wrapper .grid-body.token_details {
    grid-template-rows: 1fr 1fr 1fr 1fr;
  }
  .yt_table_wrapper .grid-body.private_dist {
    grid-template-rows: 0.25fr 0.25fr 0.25fr 1fr 0.25fr 0.25fr 0.25fr 0.25fr;
  }
  .yt_table_wrapper .grid-body.public_dist {
    grid-template-rows: 0.25fr 1fr 0.25fr 0.25fr;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations {
    grid-template-columns: 1fr 1fr 1fr;
    padding-bottom: 0;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-content label:before {
    display: none;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-content label:first-child {
    border-radius: 0;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-content label:last-child {
    border-radius: 0;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-content .table_row:last-child label {
    border-bottom: 0;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-content .table_row:last-child label:first-child {
    border-radius: 0 0 0 10px;
  }
  .yt_table_wrapper .grid-body.airdrop_allocations .grid-content .table_row:last-child label:last-child {
    border-radius: 0 0 10px 0;
  }

  .yolo_token_page_wrapper form .waitlist_amount_title {
    font-size: 1rem;
    font-weight: 600;
    padding: 20px 0 10px 0;
  }
  .yolo_token_page_wrapper .yt_page_left form.submit_result_tweet .waitlist_amount_title {
    border-top: 1px solid hsla(0, 0%, 100%, 0.15);
    margin: 15px 0 0 0;
  }

  .yolo_token_page_wrapper form .waitlist_data {
    padding: 5px 0 0 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.3rem;
  }
  .yolo_token_page_wrapper form .waitlist_data .circles {
    background: url(${images.wl_circles}) center center / 85px 30px no-repeat;
    width: 85px;
    height: 30px;
    margin: 0 10px 0 0;
  }

  @media (max-width: 1600px) {
    .yolo_token_page_wrapper h1 {
      font-size: 2.6rem;
      letter-spacing: -0.03em;
      padding: 0 60px;
    }
    .yolo_token_page_wrapper h2 {
      font-size: 2.1rem;
      letter-spacing: -0.02em;
      padding: 10px 60px 0 60px;
    }
    .yolo_token_page_wrapper .yt_page_left form {
      padding: 40px 60px;
    }
    .yolo_token_page_wrapper .yt_page_left .qanda {
      padding: 0 60px;
    }
    .yolo_token_page_wrapper .yt_page_right {
      padding: 40px 60px 0 60px;
    }
    .yolo_token_page_wrapper .yt_page_right .yt_logo_full {
      width: 300px;
    }
  }
  @media (max-width: 1200px) {
    .yolo_token_page_wrapper h1 {
      font-size: 2.6rem;
      letter-spacing: -0.03em;
      padding: 0 40px;
    }
    .yolo_token_page_wrapper h2 {
      font-size: 2.1rem;
      letter-spacing: -0.02em;
      padding: 10px 40px 0 40px;
    }
    .yolo_token_page_wrapper .yt_page_left form {
      padding: 40px 40px;
    }
    .yolo_token_page_wrapper .yt_page_left .qanda {
      padding: 0 40px;
    }
    .yolo_token_page_wrapper .yt_page_right {
      padding: 40px 40px 0 40px;
    }
    .yolo_token_page_wrapper .yt_page_right .yt_logo_full {
      width: 250px;
    }
  }
  @media (max-width: 1000px) {
    .yt_table_wrapper .grid-body .grid-content label {
      flex-direction: column;
      align-items: flex-start;
    }
    .yt_table_wrapper .grid-body.airdrop_allocations .grid-content label {
      justify-content: center;
    }
    .yt_table_wrapper .grid-body .grid-content label .title {
      padding-bottom: 5px;
    }
    .yolo_token_page_wrapper h1 {
      font-size: 2.6rem;
      letter-spacing: -0.03em;
      padding: 0 30px;
    }
    .yolo_token_page_wrapper h2 {
      font-size: 2.1rem;
      letter-spacing: -0.02em;
      padding: 10px 30px 0 30px;
    }
    .yolo_token_page_wrapper .yt_page_left form {
      padding: 40px 30px;
    }
    .yolo_token_page_wrapper .yt_page_left .qanda {
      padding: 0 30px;
    }
    .yolo_token_page_wrapper .yt_page_right {
      padding: 40px 30px 0 30px;
    }
    .yolo_token_page_wrapper .yt_page_right .yt_logo_full {
      width: 200px;
    }
  }
  @media (max-width: 800px) {
    .yolo_token_page_wrapper h1 {
      font-size: 2rem;
      letter-spacing: -0.03em;
    }
    .yolo_token_page_wrapper h2 {
      font-size: 1.3rem;
      letter-spacing: -0.02em;
    }
    .yolo_token_page_wrapper {
      flex-direction: column;
    }
    .yolo_token_page_wrapper .yt_page_left,
    .yolo_token_page_wrapper .yt_page_right {
      width: 100%;
      border-right: 0;
      padding-top: 10px;
    }
    .yolo_token_page_wrapper .yt_page_left .yt_logo_full {
      width: 150px;
      display: flex;
      margin: 15px 0 0 0;
      height: 189px;
    }
    .yolo_token_page_wrapper .yt_page_right .yt_logo_full {
      display: none;
    }
  }
`

const callOutBoxesCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token.css */
  .yolo_token_page_wrapper .yt_page_right .callout_boxes {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 0 20px 0;
  }
  .yolo_token_page_wrapper .yt_page_right .callout_boxes .box {
    background: hsla(0, 0%, 100%, 0.1);
    border-radius: 10px;
    padding: 18px 30px 14px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 5px;
  }
  .yolo_token_page_wrapper .yt_page_right .callout_boxes .box .box_title {
    font-weight: 600;
    font-size: 0.9rem;
    padding: 0 0 5px 0;
  }
  .yolo_token_page_wrapper .yt_page_right .callout_boxes .box .box_value {
    font-size: 2.1rem;
    font-weight: 300;
    color: #deff00;
    letter-spacing: -0.02em;
  }
`

const investorCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  .landing_level {
    width: 90%;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    position: relative;
    z-index: 0;
    padding: 15px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .landing_level .section_heading {
    text-align: center;
  }
  .landing_level.investors {
    background: hsla(0, 0%, 0%, 0.3);
    border-top: 0;
    margin: 50px 0 0 0;
    border-radius: 10px;
    padding: 30px;
  }
  .landing_level .logos {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  .landing_level a {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px 0 0 0;
  }
  .landing_level a .logo {
    height: 50px;
  }
  .landing_level a.pantera .logo {
    background: url(${landingAssets.pantera_cap_logo_color_circle}) center center / auto 40px no-repeat;
    width: 40px;
  }
  .landing_level a.cluster .logo {
    background: url(${landingAssets.cluster_color_circle}) center center / auto 40px no-repeat;
    width: 40px;
  }
  .landing_level a.lemniscap .logo {
    background: url(${landingAssets.lemniscap_logo_color}) center center / auto 30px no-repeat;
    width: 150px;
  }
  .landing_level a.deepventures .logo {
    background: url(${landingAssets.deepventures_color_circle}) center center / auto 50px no-repeat;
    width: 50px;
  }
  .landing_level a.angeldao .logo {
    background: url(${landingAssets.angeldao_logo_color}) center center / auto 35px no-repeat;
    width: 140px;
  }
  .landing_level a.kretos .logo {
    background: url(${landingAssets.kretos_logo}) center center / auto 40px no-repeat;
    width: 40px;
  }
  .landing_level a .logo {
    width: 100%;
  }
  .landing_level a span {
    visibility: hidden;
    text-align: center;
    width: 100%;
    font-size: 0.8rem;
    line-height: 130%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .landing_level a:hover span {
    visibility: hidden;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token.css */
  .yolo_token_page_wrapper .landing_level.investors {
    width: 100%;
    margin: 0;
  }
  .yolo_token_page_wrapper .landing_level.investors .section_heading {
    font-size: 1.3rem;
    font-weight: 800;
  }
`

const twitterShareCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token.css */
  .yolo_token_page_wrapper .yt_page_left form fieldset {
    display: flex;
    flex-direction: column;
  }
  .yolo_token_page_wrapper .yt_page_left form fieldset label {
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 10px 0;
  }

  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token.css */
  .yolo_token_page_wrapper .yt_page_left form fieldset {
    display: flex;
    flex-direction: column;
  }
  .yolo_token_page_wrapper .yt_page_left form fieldset button {
    border-radius: 10px;
    padding: 10px 16px;
    font-size: 0.9rem;
    position: relative;
  }
  .yolo_token_page_wrapper .yt_page_left form.submit_result_tweet p {
    font-size: 0.85rem;
    margin: 10px 0;
  }
  .yolo_token_page_wrapper .yt_page_left form.submit_result_tweet p b {
    font-weight: 800;
  }

  .yolo_token_page_wrapper .yt_page_left form.submit_result_tweet fieldset button.tweet {
    background: linear-gradient(360deg, #0a73b3, #0d79bc, #1080c5, #1386ce, #158dd7, #1894e0, #1a9ae9, #1ca1f2);
    font-size: 1rem;
    font-weight: 600;
    width: 200px;
    padding: 10px 16px 10px 40px;
  }
  .yolo_token_page_wrapper .yt_page_left form.submit_result_tweet fieldset button.tweet:hover {
    background: linear-gradient(360deg, #1ca1f2, #1ca1f2, #1ca1f2, #1ca1f2, #1ca1f2, #1ca1f2, #1ca1f2, #1ca1f2);
  }
  .yolo_token_page_wrapper .yt_page_left form.submit_result_tweet fieldset button.tweet:before {
    -webkit-mask: url(${icons.twitter_icon}) center center / 20px auto no-repeat;
    mask: url(${icons.twitter_icon}) center center / 20px auto no-repeat;
    background: #fff;
    position: absolute;
    top: 50%;
    left: calc(50% - 30px);
    transform: translate(-50%, -50%);
    content: '';
    width: 20px;
    height: 20px;
  }
`

const footerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/global.css */
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  a {
    color: #fff;
    text-decoration: none;
    text-decoration-color: rgba(255, 255, 255, 0.4);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  a:hover {
    text-decoration: none;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsla(0, 0%, 100%, 0.15);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 0.75rem;
    padding: 30px 60px;
    margin: 30px 0 0 0;
    align-items: center;
    position: relative;
    bottom: 0;
    z-index: 11;
    width: 90%;
    flex-wrap: nowrap;
  }
  footer #landing-details {
    display: flex;
    flex-direction: row;
    min-width: auto;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  footer .about {
    opacity: 0.3;
    width: 100%;
    max-width: 600px;
    text-align: center;
    line-height: 130%;
  }
  footer .about:hover {
    opacity: 1;
  }
  footer .about div {
    display: block;
    margin: 10px 0 0 0;
  }
  footer a {
    color: rgba(255, 255, 255, 1);
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  footer a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }
  footer #copyright,
  footer #priv-terms {
    white-space: nowrap;
  }
  footer #copyright {
    padding: 5px 15px;
    margin: 0 0 5px 0;
  }
  footer #priv-terms {
    margin: 0 0 5px 0;
  }
  footer #landing-social {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 15px 0 0 0;
  }
  footer #landing-social a.icon {
    background-color: #fff;
    mask-position: center center;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 0 15px;
    display: block;
  }
  footer #landing-social a.twitter {
    mask: url(${social.twitter_icon}) no-repeat;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.tiktok {
    mask: url(${social.tiktok_icon}) no-repeat;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.medium {
    mask: url(${social.medium_icon}) no-repeat;
    mask-size: auto 18px;
    width: 22px;
    height: 18px;
  }
  footer #landing-social a.telegram {
    mask: url(${social.telegram_icon}) no-repeat;
    mask-size: auto 20px;
    width: 23px;
    height: 20px;
  }
  footer #landing-social a.discord {
    mask: url(${social.discord_icon}) no-repeat;
    mask-size: auto 20px;
    width: 26px;
    height: 20px;
  }
  footer #landing-social a.email {
    mask: url(${social.email_icon}) no-repeat;
    mask-size: auto 22px;
    width: 32px;
    height: 22px;
  }
  footer #landing-social a.icon:hover {
    background-color: #2e68eb;
  }
`
const greenTopBoxCSS = css`
  .yolo_token_page_wrapper .yt_page_left div.top_alert {
    background: hsla(68, 100%, 50%, 0.2);
    padding: 15px 100px;
    width: 100%;
    margin: 20px 0 -30px 0;
    line-height: 100%;
    position: relative;
  }
  .yolo_token_page_wrapper .yt_page_left div.top_alert:hover {
    background: hsla(68, 100%, 50%, 0.3);
    cursor: pointer;
  }
  .yolo_token_page_wrapper .yt_page_left .top_alert:before {
    mask: url(${icons.error_icon}) left center / 25px auto no-repeat;
    background: #deff00;
    position: absolute;
    left: 60px;
    top: 50%;
    transform: translateY(-50%);
    content: '';
    width: 25px;
    height: 25px;
  }
  .yolo_token_page_wrapper .yt_page_left .top_alert span {
    font-size: 0.9rem;
  }
  .yolo_token_page_wrapper .yt_page_left .top_alert span b {
    font-weight: 800;
  }
  .yolo_token_page_wrapper .yt_page_left .top_alert span .fake_link {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    display: inline;
    font-weight: 600;
    text-transform: uppercase;
  }
  .yolo_token_page_wrapper .yt_page_left .top_alert:hover span .fake_link {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }
  @media (max-width: 1600px) {
    .yolo_token_page_wrapper .yt_page_left div.top_alert {
      padding: 15px 60px 15px 100px;
    }
  }
  @media (max-width: 1200px) {
    .yolo_token_page_wrapper .yt_page_left div.top_alert {
      padding: 15px 40px 15px 80px;
    }
    .yolo_token_page_wrapper .yt_page_left .top_alert:before {
      left: 40px;
    }
  }
  @media (max-width: 1000px) {
    .yolo_token_page_wrapper .yt_page_left div.top_alert {
      padding: 15px 30px 15px 70px;
    }
    .yolo_token_page_wrapper .yt_page_left .top_alert:before {
      left: 30px;
    }
  }
  @media (max-width: 800px) {
    .yolo_token_page_wrapper .yt_page_left div.top_alert {
      margin: 20px 0 10px 0;
    }
  }
`
const reserveSpotCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token.css */
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users button.reserve_100 {
    padding: 10px 20px;
    margin: 10px 0 0 0;
    background: linear-gradient(180deg, #deff00, #d6f600, #ceed00, #c7e400, #bfdb00, #b7d200, #b0ca00, #a8c100);
    color: #000;
  }
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users button.reserve_100:hover {
    background: linear-gradient(180deg, #deff00, #deff00, #deff00, #deff00, #deff00, #deff00, #deff00, #deff00);
  }

  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token.css */
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users span b {
    font-weight: 600;
  }
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users .reserve_100_success {
    border: 1px solid hsla(68, 100%, 50%, 0.4);
    border-radius: 10px;
    padding: 10px 15px;
    line-height: 120%;
    color: #deff00;
    margin: 10px 0 0 0;
  }
  .yt_table_wrapper .grid-body .grid-content label.yolorekt_users .reserve_100_success b {
    font-weight: 600;
    color: #deff00;
  }
`
const developerCSS = css`
  .scroll_wrapper {
    margin-top: 70px;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 70px);
  }
  form .field_error {
    color: #de0e54;
    margin: 5px 0 0 0;
    font-size: 0.8rem;
  }
  .indentation {
    padding-left: 15px !important;
  }
  .investor_list {
    padding: 0 0 40px 0;
  }
  .investor_list li.item {
    padding: 5px 0 0 15px;
  }
`

export const YoloTokenCSS = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 70px;
  height: 100%;
  background: url(${images.yolo_token_bg_2}) center center / cover no-repeat;
  ${designerCSS}
  ${twitterShareCSS}
  ${callOutBoxesCSS}
  ${investorCSS}
  ${footerCSS}
  ${greenTopBoxCSS}
  ${reserveSpotCSS}
  ${developerCSS}
`
